exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-item[data-v-72ceedea]{font-size:12px}.log-item[data-v-72ceedea]:hover,.selected-folder[data-v-72ceedea]{background-color:#cae9fd}", ""]);

// exports
